import React from "react";

import { colors, fonts } from "@apps/mf-overview/src/ts/config";

/**
 * Injects global stylesheet into the DOM.
 */
export const CSS: React.FC = () => (
  <React.Fragment>
    <style jsx global>{`
      html,
      body {
        /** Reset margins and paddings */
        margin: 0;
        padding: 0;

        /** Fill up the viewport */
        width: 100%;
        height: 100%;
      }

      body {
        /** Apply horizontal padding */
        box-sizing: border-box;
        padding: 0 30px;

        /** Add top-padding equivalent to the position:fixed header */
        padding-top: 120px;

        /** Set up basic font */
        color: ${colors.black};
        font-family: ${fonts.figtree};
        font-size: 16px;
        line-height: 1.3em;
      }

      #app {
        /** Fill up the viewport */
        min-width: 100%;
        min-height: 100%;

        /** Use flexbox inside on the y-axis */
        display: flex;
        flex-direction: column;
      }

      * {
        /** Disable default touch-tap-highlight */
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }
    `}</style>
  </React.Fragment>
);
